<div class="find-us-container">
  <h2>Find Us</h2>
  <div class="contact-details">
    <p><strong>Address:</strong> {{address}}</p>
    <p><strong>Phone:</strong> <a href="tel:{{phone}}">{{phone}}</a></p>
    <p><strong>Email:</strong> <a href="mailto:{{email}}">{{email}}</a></p>
  </div>
  <div class="map-container">
    <iframe [src]="mapUrl | safeUrl" width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
  </div>
</div>